import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    height: '100%',
    marginLeft: 20,
    [theme.breakpoints.down('xs')]: {
      marginLeft: 10,
    },
  },
  button: {
    minWidth: 'auto',
    padding: 2,
  },
  icon: {
    color: '#fff',
  },
  iconActive: {
    color: 'rgb(52,122,196)',
  },
  elevation1: {
    boxShadow: '0px 3px 6px rgba(0, 0, 0, .29)',
  },
  rounded: {
    borderRadius: 0,
  },
  menuItem: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: 16,
    fontSize: 15,
    fontFamily: 'NeoSansStd',
    color: theme.custom.darkBlue,
    [theme.breakpoints.down(theme.size.sm)]: {
      fontSize: 13,
    },
  },
  portalLabel: {
    display: 'block',
    marginTop: 5,
  },
  portalIcon: {
    fontSize: '2.8rem',
    [theme.breakpoints.down(theme.size.sm)]: {
      fontSize: '2.2rem',
    },
  },
}));
